<template>
  <div class="page flex-col">
    <div class="box_1 flex-col">
      <v-head :title="title"></v-head>
      <!-- <div class="nav-bar_1 flex-col"></div> -->
      <div class="section_2 flex-col">
        <span class="paragraph_1">{{ meetingInfo.name }}<br /></span>
        <!-- <div class="box_2 flex-col"> -->
        <img v-if="meetingInfo.photoId" :src="meetingInfo.photoId" class="image_1" alt />
        <!-- {{meetingInfo.photoId}} -->
        <!-- </div> -->
        <div class="image-text_1 flex-row justify-between">
          <div class="text-group_1">
            <span class="text_2">举办时间：</span>
            <span class="text_3">{{ meetingInfo.startDate | changeTime }}至{{
              meetingInfo.endDate | changeTime
              }}</span>
          </div>
        </div>
        <div class="image-text_3 flex-row justify-between">
          <div class="text-group_3">
            <span class="text_6">举办地点：</span>
            <span class="text_7">{{ meetingInfo.provinceName }}-{{ meetingInfo.cityName }}</span>
          </div>
        </div>
        <div class="image-text_4 flex-row justify-between">
          <div class="text-group_4">
            <span class="text_8">主办单位：</span>
            <span class="text_9">{{ meetingInfo.sponsor }}</span>
          </div>
        </div>
      </div>

      <div class="section_5 flex-row">
        <div class="text-group_5 flex-col" style="overflow: hidden;">
          <van-tabs v-model:active="mode">
            <van-tab v-for="item in  meetingContentList" :key="item.id" :title="item.title" :name="item.seq">
              <div class="section_6 flex-col">
                <span v-html="item.content" class="paragraph_2">&nbsp;&nbsp;&nbsp;</span>
              </div>
            </van-tab>

          </van-tabs>

        </div>
      </div>

      <div class="block_1 flex-row justify-between">
        <el-button type="primary" @click="gobaoming()">前往报名</el-button>
        <!-- <button class="button_3 flex-col">
          <span class="text_17">前往报名</span>
        </button> -->
      </div>
    </div>
  </div>

  </div>
</template>
<script>
  import { getMeetingDetail, getPZUrl } from "../../api/dictionary.js"
  import vHead from "../../components/Subhead.vue"
  import {
    Icon,
    Row,
    Col,
    Button,
    Swipe,
    SwipeItem,
    Dialog,
    Toast,
    Tab,
    Tabs,
  } from "vant"
  export default {
    data() {
      return {
        constants: {},
        mode: "1",

        show: false,
        title: "会议详情",
        loginStatus: false,
        memberId: "",
        id: "",
        meetingInfo: "",
        loginName: "已报名，登录查看",
        canRegister: "",
        meetingContentList: []
      }
    },

    components: {
      vHead,
      [Dialog.Component.name]: Dialog.Component,
      [Icon.name]: Icon,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
    },
    mounted() {
      this.id = this.$route.query.id
      this.canRegister = this.$route.query && this.$route.query.canRegister
      this.memberId = sessionStorage.getItem("memberId")
      this.loginName = this.memberId ? "已报名，点击查看" : "已报名，登录查看"
      this.getdata()
    },
    methods: {
      getdata() {
        let params = {
          meetingId: this.id,
        }
        getMeetingDetail(params).then((res) => {
          if (res.success) {
            this.meetingInfo = res.result.meetingDTO
            this.meetingContentList = res.result.meetingContentList
            if (this.meetingInfo.photoId) {
              getPZUrl({ id: this.meetingInfo.photoId }).then((res) => {
                this.meetingInfo.photoId = res.result
              })
            }
          }
        })
      },
      gobaoming() {
        if (this.memberId) {
          this.loginStatus = true
        }
        this.$router.push({ name: "signup", query: { meetingId: this.id, loginStatus: this.loginStatus } });
      },
    },
  }
</script>
<style scoped lang="less">
  .page {
    position: relative;
    background-color: rgba(245, 245, 247, 1);
    overflow: hidden;
  }

  /deep/.van-icon {
    color: #888;
  }

  .active {
    border-style: solid;
    padding-bottom: 0.2rem;
    border-color: #fff #fff rgba(246, 109, 17, 1) #fff;
    border-width: 0.049rem;
  }

  /deep/.van-tab--active {
    color: #ee0a24;
  }

  .image_1 {
    margin-top: 16px;
    width: 100%;
    height: 218px;
  }

  .box_1 {
    background-color: rgba(245, 245, 247, 1);

  }

  .box_2 {
    img {
      width: 100%;
      max-height: 5.2rem;
      min-height: 100%;
      border-radius: 0.08rem;
    }
  }

  .nav-bar_1 {
    padding: 26px 175px 11px 26px;
  }

  .section_1 {
    width: 213px;
  }

  .label_1 {
    width: 26px;
    height: 26px;
  }

  .text_1 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-top: 4px;
  }

  .section_2 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    align-self: center;
    margin-top: 10px;
    padding: 16px 9px 16px 10px;
  }

  .paragraph_1 {
    overflow-wrap: break-word;
    width: 100%;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: center;
    line-height: 26px;
    align-self: center;
  }

  .box_2 {
    border-radius: 4px;
    margin-top: 16px;
  }

  .image-text_1 {
    width: 245px;
    margin: 16px 113px 0 21px;
  }

  .icon_1 {
    width: 14px;
    height: 15px;
    margin: 4px 0 1px 0;
  }

  .text-group_1 {
    width: 223px;
    height: 20px;
    overflow-wrap: break-word;
    font-size: 0;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_2 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_3 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .image-text_2 {
    width: 245px;
    margin: 10px 113px 0 21px;
  }

  .icon_2 {
    width: 14px;
    height: 14px;
    margin: 4px 0 2px 0;
  }

  .text-group_2 {
    width: 223px;
    height: 20px;
    overflow-wrap: break-word;
    font-size: 0;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_4 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_5 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .image-text_3 {
    width: 156px;
    margin: 10px 201px 0 22px;
  }

  .icon_3 {
    width: 12px;
    height: 16px;
    margin: 2px 0 2px 0;
  }

  .text-group_3 {
    width: 135px;
    height: 20px;
    overflow-wrap: break-word;
    font-size: 0;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_6 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_7 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .image-text_4 {
    width: 231px;
    margin: 10px 126px 0 22px;
  }

  .icon_4 {
    width: 14px;
    height: 16px;
    margin: 1px 0 3px 0;
  }

  .text-group_4 {
    width: 210px;
    height: 20px;
    overflow-wrap: break-word;
    font-size: 0;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_8 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_9 {
    display: inline-block;
    overflow-wrap: break-word;
    vertical-align: top;
    width: 240px;
    overflow: hidden;
    text-overflow: ellipsis;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .section_3 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    align-self: center;
    margin: 16px 10px 0;
    height: 40px;
    padding: 14px 150px 0 38px;
  }

  .text-wrapper_1 {
    width: 171px;
  }

  .text_10 {
    overflow-wrap: break-word;
    color: rgba(246, 109, 17, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_11 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .box_3 {
    margin: 10px 126px 0 19px;
  }

  .section_4 {
    background-color: rgba(246, 109, 17, 1);
    border-radius: 1px;
    width: 26px;
    height: 2px;
  }

  .section_5 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    /* width: 340px; */
    align-self: center;
    margin-top: 16px;
    padding: 10px 10px 80px 10px;
  }

  .text-group_5 {}

  .text_12 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin: 0 153px 0 148px;
  }

  .text-wrapper_2 {
    width: 340px;
    overflow-wrap: break-word;
    font-size: 0;
    font-weight: NaN;
    text-align: left;
    line-height: 26px;
    margin-top: 8px;
  }

  .paragraph_2 {
    /* width: 339px; */
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    line-height: 26px;
  }

  .text_13 {
    width: 365px;
    height: 387px;
    overflow-wrap: break-word;
    color: rgba(248, 95, 36, 1);
    font-size: 14px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    line-height: 26px;
  }

  .paragraph_3 {
    width: 365px;
    height: 387px;
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    line-height: 26px;
  }

  .section_6 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    /* width: 340px; */
    align-self: center;
    margin-top: 16px;
    padding: 10px 0 0 0;
  }

  .text_14 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    align-self: center;
  }

  .image_2 {
    margin-top: 10px;
  }

  .section_7 {
    position: fixed;
    bottom: 0;
    background-color: rgba(255, 255, 255, 1);
    margin: 57px auto 0;
    /* height: 150px; */
    width: 375px;
    padding: 16px 0 10px 0;
  }

  .button_1 {
    background-color: rgba(246, 109, 17, 1);
    border-radius: 25px;
    width: 300px;
    margin: 0 auto;
    padding: 13px 130px 13px 129px;
  }

  .text_15 {
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .block_1 {
    width: 100%;
    padding: 20px 0;
    text-align: center;
    position: fixed;
    bottom: 0;
    z-index: 999;
    background-color: #fff;
    box-shadow: 0px 0px 6px 0px rgba(15, 64, 245, 0.25);
  }

  .button_2 {
    border-radius: 28px;
    border: 1px solid rgba(250, 173, 122, 1);
    padding: 7px 13px 6px 14px;
  }

  .text_16 {
    overflow-wrap: break-word;
    color: rgba(250, 173, 122, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .button_3 {
    border-radius: 28px;
    border: 1px solid rgba(246, 109, 17, 1);
    padding: 7px 41px 6px 42px;
  }

  .text_17 {
    overflow-wrap: break-word;
    color: rgba(246, 109, 17, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .image_3 {
    width: 414px;
    height: 38px;
  }
</style>
